<!--
    学生管理-班级-详情
    功能：展示当前班级的详情数据
-->
<template>
  <div class="class_detail" v-loading="loading">
    <div class="total">
      <p>班级名称：{{ classInfo.name }}</p>
      <p>班级码：{{ classInfo.number }}</p>
      <p>创建时间：{{ classInfo.created_at }}</p>
      <p>创建人：{{ classInfo.created_info ? classInfo.created_info.name : '--' }}</p>
      <p>负责老师：{{ classInfo.teacher ? classInfo.teacher.name : '--' }}</p>
      <p>学生数：{{ classInfo.student_count }}</p>
      <p>上课次数：{{ classInfo.teaching_count }}</p>
    </div>
    <el-row class="student">
      <el-col :span="24">
        <h1>班级学生：</h1>
        <el-table
          :data="studentList"
          style="width: 100%"
          height="400"
          border>
          <el-table-column
            width="80px"
            label="头像">
            <template slot-scope="scope">
              <img
                class="head_url"
                :src="scope.row.student.headimgurl ? scope.row.student.headimgurl : ''"
                :onerror="scope.row.student.gender === 1 ? moveErrorBoy : moveErrorGirl"
                alt="">
            </template>
          </el-table-column>
          <el-table-column
            v-for="info in columnsStudent"
            :key="info.prop"
            :prop="info.prop"
            :label="info.label"
            :formatter="info.formatter"
          />
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            width="200px">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button-->
<!--                size="mini"-->
<!--                @click="rollOut( scope.row.student.id, 'leave')">移出班级</el-button>-->
<!--              <el-button-->
<!--                v-if="$permissions('schedule_center.bdh_class.choice_class_list')"-->
<!--                size="mini"-->
<!--                @click="transter( scope.row)">转班</el-button>-->
<!--              &lt;!&ndash; <el-button size="mini">请假</el-button> &ndash;&gt;-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-col>
<!--      <el-col :span="12">-->
<!--        <h1>转出记录：</h1>-->
<!--      </el-col>-->
    </el-row>
    <div class="class_log">
      <h1>上课记录：</h1>
      <AppList
        ref="list"
        :list.sync="list"
        title=""
        :api="`/api/liveroom/log/classes/${id}`"
        :api-type="`/api/liveroom/log/classes/${id}?is_show_teacher=1&order[id]=desc&page=1&per_page=10`">
        <template slot-scope="props">
          <el-table :data="props.listData">
            <el-table-column
              v-for="column in columns"
              v-if="!column.show"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :formatter="column.formatter"
            />
          </el-table>
        </template>
      </AppList>
    </div>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  import defaultBoy from "@/assets/images/student_boy.png";
  import defaultGirl from "@/assets/images/student_girl.png";
  export default {
    name: "ClassDetail",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id,
        classInfo: {},
        list: {},
        studentList: [],
        moveErrorBoy: 'this.src="' + defaultBoy + '"',
        moveErrorGirl: 'this.src="' + defaultGirl + '"',
        columnsStudent: [
          { prop: 'student_name', label: '学生姓名' },
          { prop: 'created_at', label: '进班时间' },
          { prop: 'student.mobile', label: '手机号' },
          { label: '练习权限', formatter: row => row.student.is_exercise_expired ? '已过期' : '进行中' },
          { prop: 'student.number', label: '学号' },
          { label: '有效期', width: '160px', formatter: row => row.student.exercise_expired && row.student.exercise_expired.exercise_expired_at ? row.student.exercise_expired.exercise_expired_at : '--' },
        ],
        columns: [
          {
            label: '直播时间',
            width: '180px',
            formatter: row => {
              let time = '';
              switch (row.status) {
                case 1: // 未开始 展示预设直播开始时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                case 2: // 直播中 展示实际直播开始时间~--
                  time = `${row.begin_time} ~ --`;
                  break;
                case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                  time = `${row.begin_time} ~ ${row.close_time}`;
                  break;
                case 4: // 缺课 预设时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                case 5: // 已取消 预设时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                default:
                  break;
              }
              return time
            }
          },
          {
            label: '直播时长',
            formatter: row => {
              const time = this.$setting.setTime(row.act_liveroom_second);
              return `${time.hour}:${time.min}:${time.sec}`
            }
          },
          { prop: 'name', label: '课题' },
          { prop: 'number', label: '教室编号' },
          { prop: 'teacher.name', label: '授课老师' },
          {
            label: '直播类型',
            formatter: row => {
              const type = {
                1: '班级直播间',
                2: '链接直播间',
                3: '线下课'
              };
              return type[row.type]
            }
          },
          {
            label: '选课类型',
            formatter: row => {
              const type = {
                1: 'AI课件',
                2: 'AI双师课件',
                3: '互动课件',
                4: '其他',
                0: '其他'
              };
              return type[row.course_type]
            }
          },
          { prop: 'course_name', label: '课时名称' },
          // { prop: 'name98', label: '课件名称' }, // 缺少
          // { prop: 'name99', label: '课件类型' }, // 缺少
          {
            label: '直播状态',
            formatter: row => {
              const status = {
                1: '未开始',
                2: '直播中',
                3: '已结束',
                4: '缺课',
                5: '已取消'
              };
              return status[row.status]
            }
          },
          {
            label: '授课班型',
            formatter: row => {
              const type = {
                1: '1v1',
                2: '1v4',
                3: '1v6',
              };
              return type[row.video_type];
            }
          },
          { prop: 'student_count', label: '班级学生数' },
          { prop: 'student_count', label: '上课总人次' }
        ],
        loading: false
      }
    },
    created() {
      this.loading = true;
      this.$http.get(`/api/classes/${this.id}`)
        .then((res) => {
          this.classInfo = res.data;
          this.$http.get(`/api/classes/student_list/${this.id}?page=1&per_page=9999`)
            .then((res) => {
              this.loading = false;
              this.studentList = res.items;
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    methods: {
      // 导出excel
      excelExport() {

      },
      // 上课统计详情
      StatisticalClass(id) {
        this.$router.push(`/statistical/class/${id}`)
      }
    }
  }
</script>

<style scoped lang="scss">
  .class_detail {
    .total {
      display: flex;
      flex-flow: row wrap;
      align-content: flex-start;
      font-size: 16px;
      color: var(--color-primary);
      border-radius: 5px;
      box-sizing: border-box;
      padding: 10px 10px 10px 10%;
      text-align: center;
      margin-bottom: 20px;
      background: #fff7e8;
      p {
        flex: 0 0 25%;
        margin: 20px 0;
        text-align: left;
        b {
          margin: 0 5px;
        }
      }
    }
    .student {
      h1 {
        font-size: 18px;
        font-weight: normal;
      }
      .head_url {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .class_log {
      h1 {
        font-size: 18px;
        font-weight: normal;
      }
      /deep/ .list-header {
        display: none;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/ClassManage/Detail.vue